import { useState } from 'react'
import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

  const persister = createSyncStoragePersister({
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  })

export default function QueryProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60000, // 1 minute
            gcTime: 600000, // 10 minutes
            retry: 1,
          },
        },
      })
  )

  return (
    <PersistQueryClientProvider
      persistOptions={{persister}}
      client={queryClient}
    >
      {children}
    </PersistQueryClientProvider>
  )
}
